import type { DateTime } from 'luxon';
import { createContext, useContext } from 'react';
import { ResultsQuery } from 'shared/forecast/results';
import { showForecastsStates } from 'shared/forecast/subqs';
import { zx } from 'shared/type';
import { z } from 'zod';
export const tabs = ['cfg', 'results', 'participation', 'resolution', 'forecasts'] as const;
export type BottomTab = (typeof tabs)[number];
const subqDisplayModes = ['order', 'resolution', 'forecast'] as const;
export type SubqDisplayMode = (typeof subqDisplayModes)[number];
export const zQuestionQuery = z.object({
  tab: zx.enumSafe(z.enum(tabs)),
  commentCollapsed: zx.nullish.bool,
  subquestion: zx.nullish.string,
  showDraft: zx.nullish.bool.default(false),
  subqDisplayMode: zx.enumSafe(z.enum(subqDisplayModes)).default('forecast'),
  editingQuestion: zx.nullish.string,
  showForecasts: zx.enumSafe(z.enum(showForecastsStates)).optional(),
  showQuestionForecast: z.boolean().optional(),
  subq_resolution_open: z.array(z.string()).optional(),
  subq_resolution_closed: z.array(z.string()).optional(),
  subq_editing: z.array(z.string()).default([]),
  ...ResultsQuery.zQueryShape
});
export type QuestionQuery = z.infer<typeof zQuestionQuery>;
export type QuestionContextProps = {
  type: 'question';
  question_id: string;
  subquestion_id?: string;
  // subquestionHighlightId?: string
  latestView?: DateTime | null;
  // question?: Pick<QuestionCfg, 'disableProposed' | 'disableQuestionForecast' | 'status'>
  isOwner?: boolean;
  readonly?: boolean;
};
export const QuestionContext = createContext<QuestionContextProps | undefined>(undefined);
export const useQuestionContext = () => {
  return useContext(QuestionContext);
};